export enum DeliveryType {
    Undefined = 0,
    Aspera = 1,
    Upload = 2,
    TechnicalFix = 3,
    DeliveryBucket = 4,
    Archive = 5
}
